export function bankIdForQuestionSave(bankId: string | null | undefined): string | null {
  const id = bankId?.trim() ?? '';
  return id === '' ? null : id;
}
